import { render, staticRenderFns } from "./ScoreRightSidebar.vue?vue&type=template&id=18635e52&scoped=true&"
import script from "./ScoreRightSidebar.vue?vue&type=script&lang=js&"
export * from "./ScoreRightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18635e52",
  null
  
)

export default component.exports